<template>
    <div>
        <button
            class="button-text button-info disabled:opacity-50 disabled:cursor-not-allowed text-left"
            :disabled="confirmedGuestsCount === 0"
            @click="exportZip"
        >
            Export QR Codes
        </button>

        <export-button-modal
            v-model="isModalVisible"
            :state="state"
            :download-url="downloadUrl"
            @closed="isModalVisible = false"
        ></export-button-modal>
    </div>
</template>

<script>
import { get } from 'vuex-pathify';
import Export from '@/mixins/Export';
import InteractsWithAbly from '@/mixins/InteractsWithAbly';
import axios from '@/util/axios';

const STATE_EXPORTING = 'exporting';
const STATE_EXPORT_READY = 'export-ready';
const STATE_FAILED = 'failed';

export default {
    mixins: [Export, InteractsWithAbly],

    props: {
        confirmedGuestsCount: {
            type: Number,
            required: true
        }
    },

    computed: {
        event: get('Event/event'),

        zendeskTicketUrl () {
            return window.urls.ticket;
        }
    },

    methods: {
        exportZip () {
            this.listenForEvents();

            this.isModalVisible = true;
            this.state = STATE_EXPORTING;

            this.initiateExport();
        },

        initiateExport () {
            axios.get(this.route('check-in.events.check-in-qrcodes.export', {
                event: this.event
            }));
        },

        listenForEvents () {
            this.$echo.private(`events.${this.event.id}.check-in-qrcodes`)
                .listen('.Domain\\CheckIn\\Events\\CheckinQrcodesExportFailed', () => {
                    this.state = STATE_FAILED;
                })
                .listen('.Domain\\CheckIn\\Events\\CheckInQrcodesExported', ({ downloadUrl }) => {
                    this.downloadUrl = downloadUrl;
                    this.state = STATE_EXPORT_READY;
                    window.location = downloadUrl;
                });
        }
    }
};
</script>
